// File: frontend/src/hooks/useNavCounters.js
// Version: 1.0 (quick-260909-qa3)
// Date: 2026-09-09
// Назначение: числа у пунктов левой колонки. Читает /api/v1/nav/counters.
//
// 🔴 РУБЕЖ АРЕНДАТОРА. Без него MLG и ELN сделали бы лишний сетевой вызов на
//    КАЖДОМ переходе. Рубеж — обещание, поэтому он ещё и ДОКАЗЫВАЕТСЯ переписью
//    page.on("request") в воротах задачи 4: у MLG вхождений /nav/counters — 0.
//
// 🔴 ОТКАЗ ИЗМЕРИТЕЛЯ ДАЁТ ПУСТОТУ, А НЕ НУЛИ. Сеть упала, ответ не 200, тело не
//    разобралось — возвращается {}. Тогда колонка не рисует НИ ОДНОГО числа.
//    Подставить здесь нули значило бы соврать «у вас ничего нет» вместо
//    «мы не знаем». [[feedback_unknown_is_not_no]]
//
// 🔴 Свой fetch, а не apiService.makeRequest: тот на 401 уводит на /login, и
//    отказ ВСПОМОГАТЕЛЬНОГО счётчика выкидывал бы человека из системы.

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useBranding } from '../context/BrandingContext';

export const useNavCounters = () => {
    const { isFitenko } = useBranding();
    const location = useLocation();
    const [counters, setCounters] = useState({});

    useEffect(() => {
        if (!isFitenko) return undefined;   // РУБЕЖ АРЕНДАТОРА
        let otmenen = false;
        fetch('/api/v1/nav/counters', { credentials: 'include' })
            .then((r) => (r.ok ? r.json() : {}))
            .then((d) => { if (!otmenen) setCounters(d && typeof d === 'object' ? d : {}); })
            .catch(() => { if (!otmenen) setCounters({}); });
        return () => { otmenen = true; };
    }, [isFitenko, location.pathname]);   // перечитывается при смене раздела

    return counters;
};

export default useNavCounters;
